import { SkeletonLoader } from '@moniebook-web/components/atoms/skeleton-loader';

import styles from './menus-skeleton.module.scss';

function Skeleton() {
    return <SkeletonLoader height='40px' width='100%' borderRadius='8px' />;
}

export function MenusLoadingSkeleton() {
    return (
        <div className={styles.loading}>
            <div className='flex animate-none flex-col gap-y-4 p-16 opacity-100'>
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
            </div>
            <hr className='h-[1px] w-full border-none bg-ui-border-default' />
            <div className='flex flex-col gap-y-4 p-16'>
                <Skeleton />
                <Skeleton />
                <Skeleton />
                <Skeleton />
            </div>
        </div>
    );
}
